// src/App.tsx
import React from "react";
import { Routes, Route, Link, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./hooks/useAuth";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./pages/home/Home";
import Login from "./pages/login/Login";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminBookings from "./pages/admin/AdminBookings";
import AdminNewBooking from "./pages/admin/AdminNewBooking";
import GuestBookingView from "./pages/guest/GuestBookingView";

function App() {
  const { isAuthenticated, logout } = useAuth();
  const location = useLocation();
  const isGuest = location.pathname.startsWith("/guest");

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-[#006838] px-4 py-3 shadow">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          {/* Logo */}
          {isGuest ? (
            <img
              src="https://plitvice-resort.com/wp-content/uploads/2020/08/Big_Bear_PLitvice_Logo-240x60.png"
              alt="EcoResort"
              className="h-10 w-auto"
            />
          ) : (
            <Link to="/">
              <img
                src="https://plitvice-resort.com/wp-content/uploads/2020/08/Big_Bear_PLitvice_Logo-240x60.png"
                alt="EcoResort"
                className="h-10 w-auto"
              />
            </Link>
          )}

          {/* Logout button if authenticated and not guest */}
          {!isGuest && isAuthenticated && (
            <button
              onClick={logout}
              className="text-sm font-medium text-white hover:underline"
            >
              Logout
            </button>
          )}
        </div>
      </header>

      {/* Page Content */}
      <main>
        <Routes>
          <Route path="/" element={<Navigate to="/admin" replace />} />
          <Route path="/guest/:hash" element={<GuestBookingView />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/bookings"
            element={
              <ProtectedRoute>
                <AdminBookings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/bookings/new"
            element={
              <ProtectedRoute>
                <AdminNewBooking />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;
